<div class="alert alert-success" *ngIf="alertSuccess">
  Folder saved successfully!
</div>
<div class="alert alert-success" *ngIf="alertUpdateSuccess">
  Folder updated successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
  {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Folder deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>

<div class="common-padding">

  <h4 class="headspace">ADDITIONAL NAAC RESOURCES >> MANAGE FOLDER</h4>
  <form class="admin-font-style" (ngSubmit)="onManageFolderSubmit()" action="" name="manageFolderForm"
    #manageFolderForm="ngForm">
    <div>


      <div class="col-md-6 inlineFlex zeroRightPad">
        <label class="col-md-3 zeroLeftPad" for="folderName">Folder Name<span class="star">*</span></label>
        <input type="text" [maxlength]="50" class="form-control col-md-8 zeroRightPad placeholder" name="folderName"
          id="folderName" placeholder="Folder Name" [(ngModel)]="folderName" required>
      </div>
      <div class="col-md-6 inlineFlex zeroRightPad">

        <label class="col-md-3 zeroLeftPad" for="folderOrder">Order<span class="star"> *</span></label>
        <input type="text" class="form-control" id="folderOrder" name="folderOrder"
          class="form-control col-md-8 zeroRightPad placeholder"
          onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
          [(ngModel)]="folderOrder" placeholder="Enter Folder order" required autocomplete="off">
      </div>

    </div>
    <div class="top-space text-center col-md-12">

      <button type="submit" *ngIf="!editAndSave" id="submitButton"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width" [disabled]="!manageFolderForm.valid"
        data-target="#myModal" data-toggle="modal">SAVE</button>
      <button type="submit" *ngIf="editAndSave" id="submitButton"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width" [disabled]="!manageFolderForm.valid"
        data-target="#myModal" data-toggle="modal">SAVE AND UPDATE</button>
      <span class="preview"></span>

      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
        data-target="#myModal" (click)="cancelClick()">BACK TO RESOURCES</button>
    </div>

  </form>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>


  <!--table-->

  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" class="folderheader">Folder Name</th>
          <th scope="col" class="folderheader">Folder Order</th>
          <th scope="col" class="actionheader">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of documentsFolderList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">

          <td class="folderheader">{{data.folderName}}</td>
          <td class="folderOrder">{{data.folderOrder}}</td>
          <td class="edit-delete-button actionheader">
            <a id="edit{{i}}" (click)="updateDocument(data,i)" class="edit-delete"><img alt="Angular Logo" src="assets/images/edit.png"
                class="image" title="Edit"></a>
            <a id="edit{{i}}" (click)="deleteFolderConfirmation(data.folderId)" class="edit-delete"
              data-target="#myModal" data-toggle="modal"><img src="assets/images/delete.png" alt="Angular Logo" class="image"
                title="Delete"></a>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)">
      </pagination-controls>
    </div>

  </div>
  <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
